/**
 * Public origins of separately deployed Trinity SPAs.
 * Keep in sync with the API's CHECKIN_PUBLIC_ORIGIN / GIVING_PUBLIC_ORIGIN.
 */

const stripTrailingSlash = (url: string) => url.replace(/\/$/, '');

const fromEnv = (value: string | undefined, fallback: string) =>
  stripTrailingSlash((value?.trim() || fallback));

export const checkinPublicOrigin = fromEnv(
  import.meta.env.VITE_CHECKIN_PUBLIC_ORIGIN as string | undefined,
  'http://localhost:5313',
);

export const givingPublicOrigin = fromEnv(
  import.meta.env.VITE_GIVING_PUBLIC_ORIGIN as string | undefined,
  'http://localhost:5314',
);

export const buildKioskPairingUrl = (pairingCode: string): string =>
  `${checkinPublicOrigin}/pair/${encodeURIComponent(pairingCode)}`;

export const buildGivingLinkUrl = (churchSlug: string, linkSlug: string): string =>
  `${givingPublicOrigin}/${encodeURIComponent(churchSlug)}/${encodeURIComponent(linkSlug)}`;

export const buildProgramRegistrationUrl = (churchSlug: string, programId: string): string =>
  `${givingPublicOrigin}/${encodeURIComponent(churchSlug)}/register/${encodeURIComponent(programId)}`;
